import { Content, List, Root, Trigger } from "@radix-ui/react-tabs";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type TabsProps = ComponentProps<typeof Root>;
type TabsListProps = ComponentProps<typeof List>;
type TabsTriggerProps = ComponentProps<typeof Trigger>;
type TabsContentProps = ComponentProps<typeof Content>;

export const Tabs: FC<TabsProps> = ({ className, ...props }) => (
  <Root
    data-slot="tabs"
    className={cn("flex flex-col gap-2", className)}
    {...props}
  />
);

export const TabsList: FC<TabsListProps> = ({ className, ...props }) => (
  <List
    data-slot="tabs-list"
    className={cn(
      "bg-muted text-muted-foreground inline-flex h-10 w-fit items-center justify-center rounded-sm p-1",
      className,
    )}
    {...props}
  />
);

export const TabsTrigger: FC<TabsTriggerProps> = ({ className, ...props }) => (
  <Trigger
    data-slot="tabs-trigger"
    className={cn(
      "data-[state=active]:bg-background data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring inline-flex items-center justify-center gap-2 rounded-xs px-2 py-1.5 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-xs [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
      className,
    )}
    {...props}
  />
);

export const TabsContent: FC<TabsContentProps> = ({ className, ...props }) => (
  <Content
    data-slot="tabs-content"
    className={cn("flex-1 outline-none", className)}
    {...props}
  />
);
